<mat-toolbar>
  <mat-toolbar-row>
    Visão Consolidada
    <span class="spacer"></span>
    <button mat-raised-button color="primary" (click)="getStatus()">
      Atualizar
    </button>
  </mat-toolbar-row>
</mat-toolbar>

<table mat-table [dataSource]="statusList" class="col-12 tickets">
  <ng-container matColumnDef="Status">
    <th mat-header-cell *matHeaderCellDef>Status</th>
    <td class="align-middle" mat-cell *matCellDef="let element">
      {{ element.Status.Description }}
    </td>
  </ng-container>

  <ng-container matColumnDef="Quota">
    <th mat-header-cell *matHeaderCellDef>Cotas</th>
    <td mat-cell *matCellDef="let element" [class.hasItems]="element.Quota > 0">
      <div (click)="goTo(TicketType.Quota, element.Status.Id)">
        {{ element.Quota }}
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="CETIP">
    <th mat-header-cell *matHeaderCellDef>RF - Título Privado</th>
    <td mat-cell *matCellDef="let element" [class.hasItems]="element.CETIP > 0">
      <div (click)="goTo(TicketType.CETIP, element.Status.Id)">
        {{ element.CETIP }}
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="SELIC">
    <th mat-header-cell *matHeaderCellDef>RF - Título Público</th>
    <td mat-cell *matCellDef="let element" [class.hasItems]="element.SELIC > 0">
      <div (click)="goTo(TicketType.SELIC, element.Status.Id)">
        {{ element.SELIC }}
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="Futures">
    <th mat-header-cell *matHeaderCellDef>Futuros</th>
    <td
      mat-cell
      *matCellDef="let element"
      [class.hasItems]="element.Futures > 0"
    >
      <div (click)="goTo(TicketType.Futures, element.Status.Id)">
        {{ element.Futures }}
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="Margin">
    <th mat-header-cell *matHeaderCellDef>Margem</th>
    <td
      mat-cell
      *matCellDef="let element"
      [class.hasItems]="element.Margin > 0"
    >
      <div (click)="goTo(TicketType.Margin, element.Status.Id)">
        {{ element.Margin }}
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="Contracted">
    <th mat-header-cell *matHeaderCellDef>Compromissada</th>
    <td
      mat-cell
      *matCellDef="let element"
      [class.hasItems]="element.Contracted > 0"
    >
      <div (click)="goTo(TicketType.Contracted, element.Status.Id)">
        {{ element.Contracted }}
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="CurrencyTerm">
    <th mat-header-cell *matHeaderCellDef>Termo de Moeda</th>
    <td
      mat-cell
      *matCellDef="let element"
      [class.hasItems]="element.CurrencyTerm > 0"
    >
      <div (click)="goTo(TicketType.CurrencyTerm, element.Status.Id)">
        {{ element.CurrencyTerm }}
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="VariableIncome">
    <th mat-header-cell *matHeaderCellDef>Renda Variável</th>
    <td
      mat-cell
      *matCellDef="let element"
      [class.hasItems]="element.VariableIncome > 0"
    >
      <div (click)="goTo(TicketType.VariableIncome, element.Status.Id)">
        {{ element.VariableIncome }}
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="SwapCetip">
    <th mat-header-cell *matHeaderCellDef>Swap CETIP</th>
    <td
      mat-cell
      *matCellDef="let element"
      [class.hasItems]="element.SwapCetip > 0"
    >
      <div (click)="goTo(TicketType.SwapCetip, element.Status.Id)">
        {{ element.SwapCetip }}
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="Loan">
    <th mat-header-cell *matHeaderCellDef>Empréstimo</th>
    <td mat-cell *matCellDef="let element" [class.hasItems]="element.Loan > 0">
      <div (click)="goTo(TicketType.Loan, element.Status.Id)">
        {{ element.Loan }}
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="Exchange">
    <th mat-header-cell *matHeaderCellDef>Cambio</th>
    <td
      mat-cell
      *matCellDef="let element"
      [class.hasItems]="element.Exchange > 0"
    >
      <div (click)="goTo(TicketType.Exchange, element.Status.Id)">
        {{ element.Exchange }}
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="Transfer">
    <th mat-header-cell *matHeaderCellDef>Transferência</th>
    <td
      mat-cell
      *matCellDef="let element"
      [class.hasItems]="element.Transfer > 0"
    >
      <div (click)="goTo(TicketType.Transfer, element.Status.Id)">
        {{ element.Transfer }}
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="Expenses">
    <th mat-header-cell *matHeaderCellDef>Despesas</th>
    <td
      mat-cell
      *matCellDef="let element"
      [class.hasItems]="element.Expenses > 0"
    >
      <div (click)="goTo(TicketType.Expenses, element.Status.Id)">
        {{ element.Expenses }}
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="Liabilities">
    <th mat-header-cell *matHeaderCellDef>Passivo</th>
    <td
      mat-cell
      *matCellDef="let element"
      [class.hasItems]="element.Liabilities > 0"
    >
      <div (click)="goTo(TicketType.Liabilities, element.Status.Id)">
        {{ element.Liabilities }}
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="StructuredOperations">
    <th mat-header-cell *matHeaderCellDef>Operações Estruturadas</th>
    <td
      mat-cell
      *matCellDef="let element"
      [class.hasItems]="element.StructuredOperations > 0"
    >
      <div (click)="goTo(TicketType.StructuredOperations, element.Status.Id)">
        {{ element.StructuredOperations }}
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="StructuredOperationOrder">
    <th mat-header-cell *matHeaderCellDef>Ordens de Operações Estruturadas</th>
    <td
      mat-cell
      *matCellDef="let element"
      [class.hasItems]="element.StructuredOperationOrder > 0"
    >
      <div
        (click)="goTo(TicketType.StructuredOperationOrder, element.Status.Id)"
      >
        {{ element.StructuredOperationOrder }}
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="columns"></tr>
  <tr mat-row *matRowDef="let row; columns: columns"></tr>
</table>

<br />

<mat-toolbar>
  <mat-toolbar-row>
    Boletas Canceladas
    <span class="spacer"></span>
    <button mat-raised-button color="primary" (click)="getStatus()">
      Atualizar
    </button>
  </mat-toolbar-row>
</mat-toolbar>

<table mat-table [dataSource]="statusListCancel" class="col-12 tickets">
  <ng-container matColumnDef="Status">
    <th mat-header-cell *matHeaderCellDef>Status</th>
    <td class="align-middle" mat-cell *matCellDef="let element">
      {{ element.Status.Description }}
    </td>
  </ng-container>

  <ng-container matColumnDef="Quota">
    <th mat-header-cell *matHeaderCellDef>Cotas</th>
    <td mat-cell *matCellDef="let element" [class.hasItems]="element.Quota > 0">
      <div (click)="goTo(TicketType.Quota, element.Status.Id)">
        {{ element.Quota }}
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="CETIP">
    <th mat-header-cell *matHeaderCellDef>RF - Título Privado</th>
    <td mat-cell *matCellDef="let element" [class.hasItems]="element.CETIP > 0">
      <div (click)="goTo(TicketType.CETIP, element.Status.Id)">
        {{ element.CETIP }}
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="SELIC">
    <th mat-header-cell *matHeaderCellDef>RF - Título Público</th>
    <td mat-cell *matCellDef="let element" [class.hasItems]="element.SELIC > 0">
      <div (click)="goTo(TicketType.SELIC, element.Status.Id)">
        {{ element.SELIC }}
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="Futures">
    <th mat-header-cell *matHeaderCellDef>Futuros</th>
    <td
      mat-cell
      *matCellDef="let element"
      [class.hasItems]="element.Futures > 0"
    >
      <div (click)="goTo(TicketType.Futures, element.Status.Id)">
        {{ element.Futures }}
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="Margin">
    <th mat-header-cell *matHeaderCellDef>Margem</th>
    <td
      mat-cell
      *matCellDef="let element"
      [class.hasItems]="element.Margin > 0"
    >
      <div (click)="goTo(TicketType.Margin, element.Status.Id)">
        {{ element.Margin }}
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="Contracted">
    <th mat-header-cell *matHeaderCellDef>Compromissada</th>
    <td
      mat-cell
      *matCellDef="let element"
      [class.hasItems]="element.Contracted > 0"
    >
      <div (click)="goTo(TicketType.Contracted, element.Status.Id)">
        {{ element.Contracted }}
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="CurrencyTerm">
    <th mat-header-cell *matHeaderCellDef>Termo de Moeda</th>
    <td
      mat-cell
      *matCellDef="let element"
      [class.hasItems]="element.CurrencyTerm > 0"
    >
      <div (click)="goTo(TicketType.CurrencyTerm, element.Status.Id)">
        {{ element.CurrencyTerm }}
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="VariableIncome">
    <th mat-header-cell *matHeaderCellDef>Renda Variável</th>
    <td
      mat-cell
      *matCellDef="let element"
      [class.hasItems]="element.VariableIncome > 0"
    >
      <div (click)="goTo(TicketType.VariableIncome, element.Status.Id)">
        {{ element.VariableIncome }}
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="SwapCetip">
    <th mat-header-cell *matHeaderCellDef>Swap CETIP</th>
    <td
      mat-cell
      *matCellDef="let element"
      [class.hasItems]="element.SwapCetip > 0"
    >
      <div (click)="goTo(TicketType.SwapCetip, element.Status.Id)">
        {{ element.SwapCetip }}
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="Loan">
    <th mat-header-cell *matHeaderCellDef>Empréstimo</th>
    <td mat-cell *matCellDef="let element" [class.hasItems]="element.Loan > 0">
      <div (click)="goTo(TicketType.Loan, element.Status.Id)">
        {{ element.Loan }}
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="Exchange">
    <th mat-header-cell *matHeaderCellDef>Cambio</th>
    <td
      mat-cell
      *matCellDef="let element"
      [class.hasItems]="element.Exchange > 0"
    >
      <div (click)="goTo(TicketType.Exchange, element.Status.Id)">
        {{ element.Exchange }}
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="Transfer">
    <th mat-header-cell *matHeaderCellDef>Transferência</th>
    <td
      mat-cell
      *matCellDef="let element"
      [class.hasItems]="element.Transfer > 0"
    >
      <div (click)="goTo(TicketType.Transfer, element.Status.Id)">
        {{ element.Transfer }}
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="Expenses">
    <th mat-header-cell *matHeaderCellDef>Despesas</th>
    <td
      mat-cell
      *matCellDef="let element"
      [class.hasItems]="element.Expenses > 0"
    >
      <div (click)="goTo(TicketType.Expenses, element.Status.Id)">
        {{ element.Expenses }}
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="Liabilities">
    <th mat-header-cell *matHeaderCellDef>Passivo</th>
    <td
      mat-cell
      *matCellDef="let element"
      [class.hasItems]="element.Liabilities > 0"
    >
      <div (click)="goTo(TicketType.Liabilities, element.Status.Id)">
        {{ element.Liabilities }}
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="StructuredOperations">
    <th mat-header-cell *matHeaderCellDef>Operações Estruturadas</th>
    <td
      mat-cell
      *matCellDef="let element"
      [class.hasItems]="element.StructuredOperations > 0"
    >
      <div (click)="goTo(TicketType.StructuredOperations, element.Status.Id)">
        {{ element.StructuredOperations }}
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="StructuredOperationOrder">
    <th mat-header-cell *matHeaderCellDef>Ordens de Operações Estruturadas</th>
    <td
      mat-cell
      *matCellDef="let element"
      [class.hasItems]="element.StructuredOperationOrder > 0"
    >
      <div
        (click)="goTo(TicketType.StructuredOperationOrder, element.Status.Id)"
      >
        {{ element.StructuredOperationOrder }}
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="columns"></tr>
  <tr mat-row *matRowDef="let row; columns: columns"></tr>
</table>

<br />

<mat-toolbar>
  <mat-toolbar-row>
    Transferências
    <span class="spacer"></span>
    <button mat-raised-button color="primary" (click)="getTransfersStatus()">
      Atualizar
    </button>
  </mat-toolbar-row>
</mat-toolbar>

<table mat-table [dataSource]="transferStatusList" class="col-md-12">
  <ng-container matColumnDef="Status">
    <th mat-header-cell *matHeaderCellDef>Status</th>
    <td class="align-middle" *matCellDef="let element">
      <span
        [ngClass]="
          element.statusDescription == 'Transferência com Erro' ? 'error' : ''
        "
        >{{ element.statusDescription }}</span
      >
    </td>
  </ng-container>
  <ng-container matColumnDef="Count">
    <th mat-header-cell *matHeaderCellDef>Quantidade</th>
    <td class="align-middle" mat-cell *matCellDef="let element">
      <span
        [ngClass]="
          element.statusDescription == 'Transferência com Erro' ? 'error' : ''
        "
        >{{ element.count }}</span
      >
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="transferColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: transferColumns"></tr>
</table>
